const getHoraireData = () => {
  const date = new Date()
  const jour = date.getDay()
  const heure = date.getHours()
  const minutes = date.getMinutes()

  let isOpen = false
  let horaireText = ""

  if (jour >= 1 && jour <= 5) {
    if (heure < 9) {
      isOpen = false
      horaireText = "Fermée, ouvre à 9h."
    } else if (heure < 12 || (heure === 12 && minutes < 45)) {
      isOpen = true
      horaireText = "Ouverte, ferme à 12h45."
    } else if (heure < 13 || (heure === 13 && minutes < 45)) {
      isOpen = false
      horaireText = "Fermée, ouvre à 13h45."
    } else if (heure < 17) {
      isOpen = true
      horaireText = "Ouverte, ferme à 17h."
    } else if (jour === 5) {
      isOpen = false
      horaireText = "Fermée, ouvre lundi à 9h."
    } else {
      isOpen = false
      horaireText = "Fermée, ouvre demain à 9h."
    }
  } else {
    isOpen = false
    horaireText = "Fermée, ouvre lundi à 9h."
  }

  return {
    isOpen,
    horaireText,
  }
}

module.exports = {
  getHoraireData,
}
